<template>
    <BookingNavBar />

    <div class="container custom_container">
        <div class="row">

            <SideBar :currentStep="currentStep" />

            
            <component :is="currentFormComponent" @nextStep="handleNextStep" @backStep="handleBackStep"/>
            
        </div>
    </div>
    <BookingFooter />
</template>
<script>
import BookingFooter from '@/components/BookingFooter/BookingFooter.vue';
import BookingNavBar from '@/components/BookingNavBar/BookingNav.vue';
import SideBar from '@/components/Booking/SideBar/BookingSideBar.vue';
import ApplicantDetails from '@/components/Booking/ApplicationForms/ApplicantDetails.vue';
import SelectSlot from '@/components/Booking/ApplicationForms/SelectSlot.vue'; 
import PaymentSummary from '@/components/Booking/ApplicationForms/PaymentSummary.vue';
import FormPage from '@/components/Booking/ApplicationForms/Form.vue';
import VerifyEmailAddressModel from '@/components/Booking/ApplicationForms/models/verifyEmail.vue'

export default {
  name: 'BookingHomePage',
  components: {
    BookingFooter,
    BookingNavBar,
    SideBar,
    ApplicantDetails,
    SelectSlot,
    PaymentSummary,
    FormPage,
    VerifyEmailAddressModel,
  },
  data() {
    return {
      currentStep: 1,
    };
  },
  computed: {
    currentFormComponent() {
      switch (this.currentStep) {
        case 1:
          return 'ApplicantDetails';
        case 2:
          return 'SelectSlot';
        case 3:
          return 'PaymentSummary';
        case 4:
          return 'VerifyEmailAddressModel';

        case 5:
          return 'FormPage';
        
        default:
          return 'ApplicantDetails';
      }
    },
  },
  methods: {
    handleNextStep() {
      ///console.log('handleNextStep triggered!', this.currentStep);
      if (this.currentStep < 6) this.currentStep++;
    },
    handleBackStep() {
      //console.log('BACK STEP RECEIVED', this.currentStep);
      if (this.currentStep > 1) this.currentStep--;
    },

  },
};
</script>
<style>

html, body {
  height: 100%;
  margin: 0;
  padding: 0;
  overflow-y: auto !important;
}

.container.custom_container {
  min-height: 100vh;
  overflow: visible;
}

.row {
  height: auto;
}

.component-wrapper {
  overflow-y: auto;
  max-height: 80vh; /* or 100vh minus navbar/footer */
}

</style>